import { AbilityBuilder, createMongoAbility, type MongoAbility } from '@casl/ability';
import { parsePermissionId } from './permission-id';

/** `[action, subject]`, where subject is `<module>.<resource>`. */
export type AppAbility = MongoAbility<[string, string]>;

/**
 * Builds the CASL ability for a set of granted permission ids.
 *
 * Malformed ids are ignored (fail closed): they never grant anything. `manage` keeps its
 * CASL meaning — `core.organization.manage` allows every action on `core.organization`.
 */
export function buildAbility(permissionIds: Iterable<string>): AppAbility {
  const { can, build } = new AbilityBuilder<AppAbility>(createMongoAbility);
  for (const id of permissionIds) {
    const parsed = parsePermissionId(id);
    if (parsed) can(parsed.action, parsed.subject);
  }
  return build();
}

/** Checks one permission id against an ability. Malformed ids are always denied. */
export function canPermission(ability: AppAbility, permissionId: string): boolean {
  const parsed = parsePermissionId(permissionId);
  return parsed ? ability.can(parsed.action, parsed.subject) : false;
}
